import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyVisibleActionButtonsPipe } from '../../pipes/only-visible-action-buttons.pipe';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { ActionButton } from '../../models/action-button';

@Component({
  selector: 'app-action-buttons',
  imports: [CommonModule, OnlyVisibleActionButtonsPipe, ActionButtonComponent],
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss'],
})
export class ActionButtonsComponent<Action> {
  public readonly actions = input.required<ActionButton<Action>[]>();
}
